import React, { useEffect, useState } from "react";
import { useDispatch, useSelector }   from "react-redux";
import {
  fetchAttendanceByTrainingCard,
  patchAttendanceOnly,
} from "../../../../../store/learnerAttendanceSlice";
import { fetchLearners } from "../../../../../store/learnersSlice";

// import "../../../Styles/Common.css";               // for .switch/.slider
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LearnerAttendanceList = ({ tcId }) => {
  const dispatch = useDispatch();

  // pull redux state
  const { byTrainingCard, loading, saving, error } =
    useSelector((s) => s.learnerAttendance);
  const attendance = byTrainingCard[tcId] || [];

  const {
    learners,
    loading: lrnLoading,
    error: lrnError,
  } = useSelector((s) => s.learners);

  // which rows are currently being saved (so we can disable that checkbox)
  const [savingIds, setSavingIds] = useState(new Set());

  const [search, setSearch] = useState("");

  // fetch data when tcId changes
  useEffect(() => {
    if (tcId) dispatch(fetchAttendanceByTrainingCard(tcId));
    dispatch(fetchLearners());
  }, [dispatch, tcId]);

  const nameOf = (learnerId) => {
    const l = learners.find((lrn) => lrn.id === learnerId);
    return l ? `${l.firstName} ${l.lastName}` : `#${learnerId}`;
  };

  const toggleAttendance = (rec) => {
    const newVal = rec.Attendance === "P" ? "A" : "P";
    // mark this row as “saving”
    setSavingIds((ids) => new Set(ids).add(rec.id));

    dispatch(
      patchAttendanceOnly({ id: rec.id, Attendance: newVal })
    )
      .unwrap()
      .then(() => toast.success("Attendance updated"))
      .catch(() => toast.error("Update failed"))
      .finally(() => {
        // unmark saving
        setSavingIds((ids) => {
          const next = new Set(ids);
          next.delete(rec.id);
          return next;
        });
      });
  };

  if ((loading && attendance.length === 0) || lrnLoading) {
    return <p>Loading…</p>;
  }
  if (error || lrnError) {
    return <p className="error">{error || lrnError}</p>;
  }

  const filtered = attendance
    .filter((a) =>
      nameOf(a.learnerId).toLowerCase().includes(search.toLowerCase())
    )
    .sort(
      (a, b) =>
        new Date(b.AttendanceDate) - new Date(a.AttendanceDate)
    );

  return (
    <div className="container">
      <ToastContainer position="bottom-right" autoClose={2500} />

      <h2>
        Attendance — Training Card #{tcId}
        <input
          className="filter-input"
          placeholder="Search learner…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ marginLeft: "1rem" }}
        />
      </h2>

      <table className="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Learner</th>
            <th>Present? (P/A)</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((rec, i) => (
            <tr key={rec.id}>
              <td>{i + 1}</td>
              <td>{rec.AttendanceDate}</td>
              <td>{nameOf(rec.learnerId)}</td>
              <td style={{ textAlign: "center" }}>
                <label className="switch">
                  <input
                    type="checkbox"
                    disabled={savingIds.has(rec.id)}
                    checked={rec.Attendance === "P"}
                    onChange={() => toggleAttendance(rec)}
                  />
                  <span className="slider round" />
                </label>
              </td>
            </tr>
          ))}
          {filtered.length === 0 && (
            <tr>
              <td colSpan={4} style={{ textAlign: "center" }}>
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LearnerAttendanceList;
